module.exports = __webpack_public_path__ + "img/11.4c5f26a2.jpg";